export default __webpack_public_path__ + "static/media/trash.852c9685.svg";